import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\USUARIO\\Escritorio\\¨MERCALIA¨\\SITIO WEB\\mercaliaconnect\\src\\app\\privacy\\components\\PrivacyContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\USUARIO\\Escritorio\\¨MERCALIA¨\\SITIO WEB\\mercaliaconnect\\src\\components\\FooterClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\USUARIO\\Escritorio\\¨MERCALIA¨\\SITIO WEB\\mercaliaconnect\\src\\components\\Header.tsx");
